/* eslint-disable prefer-const */
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import styled from 'styled-components';

import DifferenceComponent from './DifferenceComponent';
import { groupBy } from '../../../utils/collection';
import { getPercentDifference } from '../../../utils/period/PercentComponent';
import { DATE_CHART_FORMAT, FULL_DATE_CHART_FORMAT } from '../../../constants/date';

const StyledSpan = styled.span`
  margin-right: 10px;
`;

const createDiff = (pointsArr, basePoint) => {
  // очищенный массив от basePoint
  const filteredArr = pointsArr.filter(({ point }) => point.uniqueChar.length !== 1);

  const diffsArr = filteredArr.map((item) => {
    let diff;
    let percentDiff;

    if (basePoint) {
      diff = basePoint.y - item.y;
      percentDiff =
        diff < 0
          ? getPercentDifference(item.y, basePoint.y) * -1 // поменял недавно
          : getPercentDifference(item.y, basePoint.y);
    }
    const { uniqueChar } = item.point;

    return {
      uniqueChar,
      differenceValue: diff,
      differencePercent: percentDiff,
    };
  });

  return diffsArr;
};

const PeriodLineTooltip = (chart, data) => {
  const { points, x } = chart;

  // проверка на содержание в поинтах нескольких периодов.
  const isAdditionalPeriod = ({ point }) => {
    const charsArray = point.uniqueChar.split('');
    const filteredCharsArray = charsArray.filter((char) => Number(char));
    const lengthOfCharsArray = filteredCharsArray.length;

    // возвращает длинну массива цифр которые были в charString
    return lengthOfCharsArray;
  };

  const isCalcDifference = Object.values(groupBy(points, isAdditionalPeriod)).length > 1;
  let category = '';

  const rows = points.reduce((res, p) => {
    const name = p.point.eventName;

    // поинт основного периода
    const basicPoint = points.find(({ point }) => {
      return point.uniqueChar === name[0];
    });

    // массив данных с различиями от основного периода
    const diffsArray = createDiff(points, basicPoint);

    // определяется относительно какого периода считается разница(сейчас стоит относительно дополнительного на основном).
    // приводится к Boolean и берется противоположное
    const isShowDifference = !isAdditionalPeriod(p);

    // находима дату у которой есть категория соответствующая текущему x
    const targetData = data.find((item) => {
      return item.categories[x] !== undefined;
    });

    // для того чтобы выводить эту категорию в tooltip
    category = data ? targetData.categories[x] : '';

    return res.concat([
      {
        date: p.key,
        value: p.y,
        name,
        isShowDifference: isShowDifference && isCalcDifference && basicPoint !== undefined,
        diffsArr: diffsArray,
        periods: p.series.userOptions.periods,
        category,
        format: p.series.userOptions.isHour ? FULL_DATE_CHART_FORMAT : DATE_CHART_FORMAT,
      },
    ]);
  }, []);

  const pointsHtml = rows.map((row, index) => {
    const {
      format,
      periods,
      category: rowItemCategory,
      date,
      name,
      value,
      isShowDifference,
      diffsArr,
    } = row;

    // отображаем diff только доп. периодов своего event
    const filterDiffsArr = diffsArr.filter((item) => {
      const firstCharDiff = item.uniqueChar[0];
      const firstCharName = name[0];

      return firstCharDiff === firstCharName;
    });

    return ReactDOMServer.renderToStaticMarkup(
      // eslint-disable-next-line react/no-array-index-key
      <div key={index}>
        <div>
          <StyledSpan>{name}</StyledSpan>
          {periods}
        </div>
        <div>
          <StyledSpan>{rowItemCategory}</StyledSpan>
          {rowItemCategory !== date ? moment(date).format(format) : ''}
        </div>
        <div>
          <StyledSpan>Value:</StyledSpan>
          <span className="tooltip-bold">{value}</span>
        </div>
        {!!isShowDifference && <DifferenceComponent diffsArr={filterDiffsArr} />}
      </div>
    );
  });

  return [ReactDOMServer.renderToStaticMarkup(<div>{category}</div>)].concat(pointsHtml);
};

export default PeriodLineTooltip;
